<section class="vc-admin-entity-detail">
  <app-admin-page-header
    titleKey="ADMIN.MARKETING.CHANNELS.ALL"
    descriptionKey="ADMIN.IA.MARKETING.DESCRIPTION"
    [showBack]="true"
    [backLink]="backLink"
    contextLabelKey="COMMON.NAME"
    [contextValue]="channel?.name || ''"
  ></app-admin-page-header>

  <div class="vc-admin-entity-detail__content">
    <nav class="vc-admin-detail__tabs">
      <a class="vc-admin-detail__tab active" aria-current="page">
        <i class="fas fa-pen"></i>
        <span>{{ 'COMMON.EDIT' | translate }}</span>
      </a>
    </nav>

    @if (loading) {
      <app-admin-state-panel mode="loading" titleKey="COMMON.LOADING"></app-admin-state-panel>
    } @else if (hasError || !channel) {
      <app-admin-state-panel
        mode="error"
        titleKey="COMMON.ERROR"
        descriptionKey="ADMIN.MARKETING.CHANNELS.ERROR.LOAD"
        [showRetry]="true"
        (retry)="load()"
      ></app-admin-state-panel>
    } @else {
      <app-admin-form-layout>
        <app-form-marketing-channel
          [payload]="channel"
          [showIntro]="false"
          [onUpdate]="reload"
        ></app-form-marketing-channel>
      </app-admin-form-layout>
    }
  </div>
</section>
